// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"L4-z","cancel":"M4-z","disabled":"N4-z","delete":"O4-z"};